/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'

import { Modal, useModal } from '@cred/react-overlay'

import styles from './styles.module.scss'

const DisclosureModal = ({
  title,
  name,
  children,
  vertical = 'default',
  onOpenModalHandler = () => {},
}) => {
  const { open, close, isOpen } = useModal({ name })

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <p
        className={vertical === 'savings' ? styles.secondaryDisclaimer : styles.disclaimer}
        onClick={() => {
          onOpenModalHandler?.()
          open()
        }}
      >
        {title}
      </p>
      <section className={styles.modal}>
        <Modal dismissible close={close} isOpen={isOpen}>
          <p className={`${styles.header} bold bodySmall`}>{title}</p>
          <div className={styles.content}>{children}</div>
          <div className={styles.footer}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <p className="align-right" onClick={close}>
              Close
            </p>
          </div>
        </Modal>
      </section>
    </>
  )
}

DisclosureModal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
  name: PropTypes.string.isRequired,
  vertical: PropTypes.string,
  onOpenModalHandler: PropTypes.func,
}

export { DisclosureModal }

export default DisclosureModal
